import { useState } from 'react';
import styles from './Madeiras.module.scss';
import NavBar from '../../components/NavBar';
import CabecalhoMadeiras from '../../components/CabecalhoMadeiras';
import SectionMadeiras from '../../components/Section/SectionMadeiras';
import ReceberMadeira from '../../components/ReceberMadeira';

const Madeiras = () => {
    const [click, setClick] = useState<boolean>(false);
    const [clickEstoque, setClickEstoque] = useState<boolean>(false);

    const mostrarform = (): void => {
        setClickEstoque(false);
        setClick(!click);
    }

    const mostraMadeiras = (): void => {
        setClick(false);
        setClickEstoque(!clickEstoque);
    }

    return (
        <main className={styles.container}>
            <NavBar />

            <div>
                <CabecalhoMadeiras mostrarform={mostrarform} mostraMadeiras={mostraMadeiras} />

                {click && <ReceberMadeira />}

                {clickEstoque && <SectionMadeiras />}
            </div>
        </main>
    )
}

export default Madeiras;